/** @format */

export const operationStatus = {
    OPERATION_STATUS_NOP: null,
    OPERATION_STATUS_BREAK: 1,
    OPERATION_STATUS_BREAK_ERROR_STOP: 2,
    OPERATION_STATUS_BREAK_OK_STOP: 3,
    OPERATION_RESTART_FROM_CURRENT_POSITION: 4,
    OPERATION_CHANGE_POSITION_PARAMS: 5,
    OPERATION_FINISH_BLOCK_AS_ERROR: 6,
    OPERATION_FINISH_BLOCK_AS_OK: 7,
};

export const operationAction = {
    OPERATION_TYPE_NO_ACTION: -1,
    OPERATION_RESTART: 1,
    OPERATION_BREAK: 2,
    OPERATION_RESTART_FROM_CURRENT_POSITION: 4,
    OPERATION_CHANGE_POSITION_PARAMS: 5,
    OPERATION_ERROR_STOP: 6,
    OPERATION_OK_STOP: 7,
    OPERATION_CANCEL: 8,
    OPERATION_SKIP_CURRENT_POSITION: 9,
};
